import { campaignKeys, useCampaign } from '@hprofits/api-client';
import { useQueryClient } from '@tanstack/vue-query';

import { apiClient } from '@/api-client/client';
import { CampaignGroupParams } from '@/modules/campaigns/composables/context/types';
import { toErrorRef } from '@/modules/common/state/toErrorRef';
import { useQueryDataSource } from '@/modules/common/state/useQueryDataSource';

export const useCampaignGroupDataSource = ({ campaignGroupId }: CampaignGroupParams) => {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useCampaign(apiClient, { campaignId: campaignGroupId });

  const invalidate = () => {
    return queryClient.invalidateQueries({
      queryKey: campaignKeys.byCampaign(campaignGroupId),
    });
  };

  return useQueryDataSource({
    query: {
      data,
      isLoading,
      error: toErrorRef(error), // TODO: Maybe useQueryDataSource will do this transformation?
      refetch: invalidate,
    },
  });
};
